<template>
  <admin-only redirectOnNotAuthorized>
      <v-container fluid>
        <v-toolbar color="white">
          <h2 class="headline ml-5"> <v-icon>mdi-folder</v-icon> Produkte</h2>
        </v-toolbar>
        <div class="mt-4">
          <v-btn
              color="success"
              large
              @click="addProduct"
          >
            <v-icon>mdi-file-multiple</v-icon>
            Produkt hinzufügen
          </v-btn>
          <div class="d-flex align-center">
            <v-text-field v-model="filter" clearable label="Suche" prepend-icon="mdi-magnify" hide-details style="max-width: 250em"></v-text-field>
            <v-spacer/>
            <span class="subtitle-2 ml-4 mr-2">Filter:</span>
            <v-btn-toggle v-model="statusFilter" multiple tile group color="blue accent-3" class="ml-4">
              <v-btn value="active">Aktiv</v-btn>
              <v-btn value="inactive">Inaktiv</v-btn>
            </v-btn-toggle>
            <v-spacer/>
          </div>
          <v-expansion-panels class="mt-2" multiple>
              <v-expansion-panel v-for="product in filteredProducts" :key="product.id">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <h3>{{ product.name }} <span class="text--disabled font-italic" v-if="!product.isActive">- Inaktiv</span></h3>
                    <v-btn icon @click.stop="editProduct(product)"><v-icon>mdi-pencil</v-icon></v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <span v-if="product.patternNumber" class="text--secondary">Haushaltsstelle: {{ product.patternNumber }}</span>
                  <v-data-table
                  :items="getFiltered(product.orders)"
                  :headers="[{text: 'Auftrag', value: 'name'}, {text: 'Ansatz', value: 'patternNumber'}, {text: 'Tätigkeiten', value: 'activities'}]"
                  disable-sort
                  :items-per-page="-1"
                  hide-default-footer>
                    <template #item="{ item: order }">
                      <tr class="project-table-row" :class="getInactiveClass(order)">
                        <td @click="editOrder(product, order)">{{ order.name }} <span v-if="!order.isActive" class="font-italic text--disabled">- Inaktiv</span></td>
                        <td @click="editOrder(product, order)">{{ order.patternNumber }}</td>
                        <td class="no-hover">
                          <v-data-table
                              class="inner-table"
                              :items="getFiltered(order.activities)"
                              :headers="[{text: '', value: 'position'}, {text: 'Tätigkeit', value: 'name'}, {text: 'Lohnart', value: 'extraChargeId'}]"
                              :items-per-page="-1"
                              hide-default-footer
                              disable-sort
                              :item-class="getInactiveClass"
                              @click:row="editActivity(product, order, $event)"
                          >
                            <template #item.name="{ item:activity }">
                              {{activity.name}} <span v-if="!activity.isActive" class="font-italic text--disabled">- Inaktiv</span>
                            </template>
                            <template #item.extraChargeId="{ item:activity }">
                              {{ getExtraCharge(activity.extraChargeId) }}
                            </template>
                            <template #footer>
                              <v-btn text @click="addActivity(product, order)"><v-icon>mdi-plus-box</v-icon> Tätigkeit hinzufügen</v-btn>
                            </template>
                          </v-data-table>
                        </td>
                      </tr>
                    </template>
                    <template #footer>
                      <v-btn text @click="addOrder(product)"><v-icon>mdi-plus-box</v-icon> Auftrag hinzufügen</v-btn>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-container>

      <product-dialog
          :open.sync="showProductModal"
          :product="selectedProduct"
          @close="closeProductModal"
      />
    <order-dialog
      :open.sync="showOrderModal"
      :productId="selectedProductId"
      :order="selectedOrder"
      @close="closeOrderModal"
    />
    <activity-dialog
      :open.sync="showActivityModal"
      :productId="selectedProductId"
      :orderId="selectedOrderId"
      :activity="selectedActivity"
      @close="closeActivityModal"
    />
</admin-only>
</template>

<script>
import ActivityDialog from './projekte/ActivityDialog';
import OrderDialog from './projekte/OrderDialog';
import ProductDialog from './projekte/ProductDialog';
import {mapState} from "vuex";

function nameIncludes(entry, query) {
  return entry.name.toLowerCase().includes(query);
}
export default {
  name: 'Produkte',
  components: {
    ProductDialog,
    OrderDialog,
    ActivityDialog,
  },
  computed: {
    ...mapState(['products']),
    filteredProducts() {
      const query = this.filter ? this.filter.toLowerCase() : null;

      return this.products.filter(
        x => this.statusFilterIncludes(x) && (!query || nameIncludes(x, query) || x.orders.some(y => nameIncludes(y, query) || y.activities.some(a => nameIncludes(a, query))))
      );
    },
    selectedProductId() {
      return this.selectedProduct ? this.selectedProduct.id : null;
    },
    selectedOrderId() {
      return this.selectedOrder ? this.selectedOrder.id : null;
    },
  },
  methods: {
    statusFilterIncludes(element) {
      let subElementIncludes = false;
      if(element.orders) {
        subElementIncludes = element.orders.some(this.statusFilterIncludes);
      } else if (element.activities) {
        subElementIncludes = element.activities.some(this.statusFilterIncludes);
      }
      return subElementIncludes ||
          (this.statusFilter.includes('active') && element.isActive) ||
          (this.statusFilter.includes('inactive') && !element.isActive);
    },
    getFiltered(elements) {
      return elements ? elements.filter(this.statusFilterIncludes) : elements;
    },
    getInactiveClass(element) {
      return element.isActive ? ''
          : 'font-italic text--disabled';
    },
    getExtraCharge(id) {
      const extraCharge = this.$store.state.extraCharges.find(e => e.id === id);
      return extraCharge ? extraCharge.code : '-';
    },
    createTitle(entity) {
      return entity.name;
    },
    editProduct(product) {
      this.selectedProduct = product;
      this.showProductModal = true;
    },
    editOrder(product, order) {
      this.selectedProduct = product;
      this.selectedOrder = order;
      this.showOrderModal = true;
    },
    editActivity(product, order, activity) {
      this.selectedProduct = product;
      this.selectedOrder = order;
      this.selectedActivity = activity;
      this.showActivityModal = true;
    },
    addProduct() {
      this.showProductModal = true;
      this.selectedProduct = null;
    },
    addOrder(product) {
      this.selectedProduct = product;
      this.selectedOrder = null;
      this.showOrderModal = true;
    },
    addActivity(product, order) {
      this.selectedProduct = product;
      this.selectedOrder = order;
      this.showActivityModal = true;
    },
    closeActivityModal() {
      this.selectedProduct = null;
      this.selectedOrder = null;
      this.selectedActivity = null;
      this.showActivityModal = false;
    },
    closeProductModal() {
      this.showProductModal = false;
      this.selectedProduct = null;
    },
    closeOrderModal() {
      this.selectedProduct = null;
      this.selectedOrder = null;
      this.showOrderModal = false;
    },
  },
  data: () => ({
    filter: null,
    statusFilter: [ 'active', 'inactive' ],
    showProductModal: false,
    showOrderModal: false,
    showActivityModal: false,
    selectedProduct: null,
    selectedOrder: null,
    selectedActivity: null,
  }),
};
</script>
<style lang="scss">
.project-table-row:hover > .no-hover {
  background: white !important;
}
.project-table-row {
  cursor: pointer;
  .no-hover {
    cursor: auto;
  }
  td {
    vertical-align: top;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
}
.inner-table {
  margin-top: -16px;
  margin-bottom: -16px;
  tbody > tr {
    cursor: pointer;
  }
}
</style>
